import { useEffect, useState } from 'react'

const scriptSrc = 'https://widget.stg.handshakes.ai/assets/public/index.js'

export const useHandshakesWidget = (parentElementSelector) => {
  const [widgetInstance, setWidgetInstance] = useState(null)

  useEffect(() => {
    let isMounted = true
    let localHsWidget

    const loadScriptAndInitWidget = async () => {
      try {
        // Fetch script content
        const response = await fetch(scriptSrc)
        const scriptContent = await response.text()

        // Tạo function constructor riêng thay vì window.hs_widget
        const widgetConstructor = new Function(
          `${scriptContent}; return hs_widget;`,
        )()

        // Lấy widgetProps mặc định
        const props = {
          key: 'xinbPCM8Wlv4mjVeox3hS61mCBgSIv3nubLk6aPsXscHFHsZHha5IxLKjJcIA6hh',
          hideSidePanel: false,
          hideSearch: false,
          hideZoomControls: false,
          hideNullFields: true,
          parentElementSelector,
          hideFields: {
            entity: [
              'currentNameEffectiveDate',
              'otherNamesEffectiveDate',
              'socialCreditNumber',
              'secondaryBusinessActivity',
              'secondaryBusinessActivityCode',
              'transactionDate',
            ],
            relationship: [],
          },
          functionMap_getStatus: 'hswidget_handleShowStatus',
          rightClickOptions: {
            generateNewGraph: {
              hideForGraph: ['interconnect', 'lbo', 'investee'],
            },
          },
        }

        // Tạo instance mới
        localHsWidget = new widgetConstructor(props)

        if (isMounted) setWidgetInstance(localHsWidget)
      } catch (err) {
        console.error('Failed to load Handshakes widget:', err)
      }
    }

    loadScriptAndInitWidget()

    return () => {
      isMounted = false
      if (localHsWidget?.destroy) {
        localHsWidget.destroy()
      }
    }
  }, [parentElementSelector])

  return widgetInstance
}
